export const FIELDS = [
  {
    name: 'name',
    label: 'Audience Name',
    type: 'text',
    position: '1/6',
  },
]

export const INITIAL_STATE = {
  name: '',
}
